module.exports = __webpack_public_path__ + "media/images/icon/allow_yellow-37adcf89bffcc8f92e53b7a6b492bd52.png";